import React from "react";
import styles from "./styles.module.scss";
import compactCurrencyFormatter from "../../../../../../utils/compact-currency-formatter";
import ratioCalculator from "../../../../../../utils/ratio-calculator";

const Tooltip = React.memo(({ data, x: tooltipX, y: tooltipY }) => {
  if (!data) return null;
  let { period, transactions, chargebacks, type } = data;
  let displayTransactions = transactions;
  let displayChargebacks = chargebacks;

  if (type === "amount") {
    displayTransactions = compactCurrencyFormatter.format(transactions);
    displayChargebacks = compactCurrencyFormatter.format(chargebacks);
  }

  const ratio = ratioCalculator(chargebacks, transactions);
  return (
    <div
      className={styles.tooltipContainer}
      style={{
        transform: `translate(${tooltipX}px, ${tooltipY}px)`,
      }}
    >
      <div className={styles.valueContainer}>
        <span className={styles.value}>{period}</span>
        {type === "volume" && transactions > 0 && chargebacks != 0 && (
          <span className={styles.valueRatio}>Ratio {ratio}</span>
        )}
      </div>

      <ul className={styles.tooltipList}>
        <li className={`${styles.listItem} ${styles.listItemIndustry}`}>
          <span
            className={`${styles.listItemLabel} ${styles.listItemLabelIndustry}`}
          >
            <span
              className={`${styles.listItemBullet} ${styles.listItemCircle}`}
              style={{ backgroundColor: "#4C70EF" }}
            ></span>
            <span>Transactions</span>
          </span>
          <span className={styles.listItemValue}>{displayTransactions}</span>
        </li>
        <li className={`${styles.listItem} ${styles.listItemIndustry}`}>
          <span
            className={`${styles.listItemLabel} ${styles.listItemLabelIndustry}`}
          >
            <span
              className={`${styles.listItemBullet} ${styles.listItemCircle}`}
              style={{ backgroundColor: "#E03B24" }}
            ></span>
            <span>Chargebacks</span>
          </span>
          <span className={styles.listItemValue}>{displayChargebacks}</span>
        </li>
        {/* {data.chargebacks.map((chargeback) => (
          <li
            className={`${styles.listItem} ${styles.listItemIndented} ${styles.listItemIndustry}`}
            key={chargeback.name}
          >
            <span
              className={`${styles.listItemLabel} ${styles.listItemLabelIndustry}`}
            >
              <span
                className={`${styles.listItemBullet} ${styles.listItemRoundedRect}`}
                style={{ backgroundColor: chargeback.color }}
                aria-hidden="true"
              ></span>
              <span>{chargeback.name}</span>
            </span>
            <span className={styles.listItemValue}>
              <span className={styles.listItemValuePercentage}>
                {chargeback.percentage}%
              </span>
              <span className={styles.listItemValueAmount}>
                {chargeback.amount}
              </span>
            </span>
          </li>
        ))} */}
      </ul>
    </div>
  );
});

Tooltip.displayName = "TooltipContent";

export default Tooltip;
